import React, { useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import { fillFioAction } from '@r1-frontend/entities/ContactDetail/actions/fillFio';
import { fillPhoneAction } from '@r1-frontend/entities/ContactDetail/actions/fillPhone';
import { setConfirmedPhone } from '@r1-frontend/entities/ContactDetail/actions/setConfirmedPhone';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import { ConfirmNumberPopup } from '~/src/components/ConfirmNumberPopup';
import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import EditableContactsForm from '~/src/features/full-buy/ContactPerson/EditableContactsForm';
import { MainLayout } from '~/src/features/full-buy/containers/MainLayout/MainLayout';
import { goToNextStep } from '~/src/features/full-buy/store/actions/goToNextStep';
import { TState } from '~/src/store';
import { hidePopup } from '~/src/store/reducers/popups/actions';
import { getPopupData } from '~/src/store/reducers/popups/selectors';

import * as ST from './styled';

const popupId = 'confirmPopup';

export const Contacts = (): JSX.Element | null => {
    const analytics = useAnalytics();

    const {
        fio,
        phone,
        confirmPopup,
    } = useSelector((state: TState) => ({
        fio: state.contactDetails.editedFio,
        phone: state.contactDetails.editedPhone,
        confirmPopup: getPopupData(state, popupId),
    }));

    const dispatch = useDispatch();

    const [isFIOEnterStarted, setIsFIOEnterStarted] = useState(false);
    const [isPhoneEnterStarted, setIsPhoneEnterStarted] = useState(false);

    const onFillFio = (_person: string) => {
        if (!isFIOEnterStarted) {
            analytics.contacts.startEnterName();
            setIsFIOEnterStarted(true);
        }
        dispatch(fillFioAction(_person));
    };

    const onFillPhone = (_phone: string) => {
        if (!isPhoneEnterStarted) {
            analytics.contacts.startEnterPhoneNumber();
            setIsPhoneEnterStarted(true);
        }
        dispatch(fillPhoneAction(_phone));
    };

    const onCloseConfirmPopup = () => {
        dispatch(hidePopup(popupId));
    };

    const executeFinalAction = () => {
        dispatch(goToNextStep());
    };

    const onConfirmPhone = () => {
        batch(() => {
            dispatch(setConfirmedPhone(phone));
            dispatch(hidePopup(popupId));
        });
        executeFinalAction();
    };

    return (
        <MainLayout>
            <TextWrapper $lastIndent={false}>
                <H3>Введите ваши ФИО и&nbsp;номер телефона</H3>
                <Paragraph4>
                    Они нужны, чтобы оформить заявку на&nbsp;подключение онлайн.
                    Вам останется выбрать только дату и&nbsp;время визита инженера.
                </Paragraph4>
            </TextWrapper>
            <ST.ContactPerson className={'ym-hide-content'}>
                <EditableContactsForm
                    title={''}
                    fio={fio}
                    phone={phone}
                    onFillFio={onFillFio}
                    onFillPhone={onFillPhone}
                    hideBtn={true}
                />
                <ConfirmNumberPopup
                    isOpen={confirmPopup?.isShow}
                    onClosePopup={onCloseConfirmPopup}
                    onConfirmed={onConfirmPhone}
                    phone={phone}
                    dataLayerPushCategory={analytics.category}
                />
            </ST.ContactPerson>
        </MainLayout>
    );
};
